import {Model} from "./";
import {Api} from "../api";
class ClientModel extends Model {
    constructor() {
        super(new Api("/clients"));
    }
    getClient(id, thenFunction, errorFunction) {
        this.q.setDopUrl('/detail/' + id);
        this.q.read({}, thenFunction, errorFunction);
    }

    getClients( thenFunction, errorFunction){
        this.q.setDopUrl('/my');
        this.q.read({}, thenFunction, errorFunction);
    }
    getClientsFull( thenFunction, errorFunction){
        this.q.setDopUrl('/my-full');
        this.q.read({}, thenFunction, errorFunction);
    }
}


export default new ClientModel();